import React from 'react';
import {useNavigate} from 'react-router-dom';
import {LeftOutlined} from '@ant-design/icons';
import {Button} from 'antd';

import {Header} from '../../components/Header/Header';
import Layout from '../../components/Layout/Layout';

import cls from './Policy.module.scss'

export const Policy = () => {

    const navigate = useNavigate();

    return (
        <Layout header={<Header left={<Button onClick={() => navigate(-1)} size={'small'} shape={'circle'} type={'link'}
                                              icon={<LeftOutlined/>}/>}
                                title={'Политика конфиденциальности и обработки персональных данных'}/>}>
            <div className={cls.page}>


                <h3>1. Общие условия</h3>
                <div>1.1. Настоящая Политика определяет порядок обработки и защиты Обществом с ограниченной
                    ответственностью «ЭфТиЭс» (далее – ООО «ЭфТиЭс») персональных данных физических лиц (далее –
                    Пользователь), которые могут быть получены ООО «ЭфТиЭс» при использовании Пользователем услуг
                    компании, в том числе посредством приложения AIVITA, программ, используемых ООО «ЭфТиЭс» (далее
                    –
                    Приложение).
                </div>
                <div>1.2. Целью настоящей Политики является обеспечение надлежащей защиты персональных данных,
                    которые
                    Пользователь предоставляет о себе самостоятельно при использовании Приложения с целью получения
                    услуг.
                </div>
                <div>1.3. Отношения, связанные со сбором, хранением, распространением и защитой персональных данных,
                    предоставляемых Пользователем, регулируются настоящей Политикой, иными официальными документами
                    ООО
                    «ЭфТиЭс» и действующим законодательством Российской Федерации.
                </div>
                <div>1.4. Регистрируясь и используя Приложение, Пользователь выражает свое полное согласие с
                    условиями
                    настоящей Политики.
                </div>
                <div>1.5. Пользователь выражает свое согласие на отправку ему информационных рассылок, push
                    уведомлений,
                    СМС сообщений от ООО «ЭфТиЭс».
                </div>
                <div>1.6. В случае несогласия Пользователя с условиями настоящей Политики использование Приложения
                    и/или
                    каких-либо Сервисов, доступных при использовании Приложения, должно быть немедленно прекращено.
                </div>
                <div>1.7. В случае несогласия Пользователя в получении информации от ООО «ЭфТиЭс» Пользователь может
                    отписаться от рассылки путем направления уведомления на электронную почту
                    help@fintechservice.group.
                    При поступлении уведомлений на электронную help@fintechservice.group они обрабатываются в
                    течение 48
                    часов, в результате Пользователь исключается из сегмента рассылок. Обработка персональных данных
                    в
                    отношение такого Пользователя прекращается.
                </div>


                <h3>2. Цели сбора, обработки и хранения информации</h3>
                <div>2.1. Обработка персональных данных Пользователя осуществляется в соответствии с законодательством
                    Российской Федерации. ООО «ЭфТиЭс» обрабатывает персональные данные Пользователя в следующих
                    целях:
                </div>
                <ul>
                    <li>идентификации Пользователя и создание личного кабинета Пользователя;</li>
                    <li>предоставления Пользователю услуг и доступа к Приложению;</li>
                    <li>связи с Пользователем, направлении Пользователю уведомлений и запросов;</li>
                    <li>проверки, исследования и анализа данных, позволяющих поддерживать и улучшать сервисы и разделы
                        Приложения, а также разрабатывать новые сервисы и разделы Приложения;
                    </li>
                    <li>проведения статистических и иных исследований.</li>
                </ul>


                <h3>3. Условия обработки персональных данных и ее передачи третьим лицам</h3>

                <div>3.1. ООО «ЭфТиЭс» принимает все необходимые меры для защиты персональных данных Пользователя от
                    неправомерного доступа, изменения, раскрытия или уничтожения.
                </div>
                <div>3.2. ООО «ЭфТиЭс» предоставляет доступ к персональным данным Пользователя только тем работникам и
                    подрядчикам, которым эта информация необходима для обеспечения функционирования Приложения и
                    оказания
                    Услуг.
                </div>
                <div>3.3. ООО «ЭфТиЭс» вправе использовать предоставленную Пользователем информацию, в том числе
                    персональные
                    данные, в целях обеспечения соблюдения требований действующего законодательства Российской Федерации
                    (в
                    том числе в целях предупреждения и/или пресечения незаконных и/или противоправных действий
                    Пользователей). Раскрытие предоставленной Пользователем информации может быть произведено лишь в
                    соответствии с действующим законодательством Российской Федерации по требованию суда,
                    правоохранительных
                    органов, а равно в иных предусмотренных законодательством Российской Федерации случаях.
                </div>
                <div>3.4. ООО «ЭфТиЭс» не проверяет достоверность информации, предоставляемой Пользователем, и исходит
                    из
                    того, что Пользователь в рамках добросовестности предоставляет достоверную и достаточную информацию,
                    заботится о своевременности внесения изменений в ранее предоставленную информацию при появлении
                    такой
                    необходимости, включая, но не ограничиваясь изменением номера телефона.
                </div>
                <h3>4. Условия пользования Приложения</h3>
                <div>4.1. Пользователь при использовании Приложения, подтверждает, что</div>
                <ul>

                    <li>• обладает всеми необходимыми правами, позволяющими ему присоединиться к действующей оферте и
                        использовать Приложение;
                    </li>
                    <li>• указывает достоверную информацию о себе в объемах, необходимых для использования Приложения;
                    </li>
                    <li>• осознает, что информация в Приложении, размещаемая Пользователем о себе, может становиться
                        доступной
                        для третьих лиц, не оговоренных в настоящей Политике и может быть скопирована и распространена
                        ими;
                    </li>
                    <li>• ознакомлен с настоящей Политикой, выражает свое согласие с ней и принимает на себя указанные в
                        ней
                        права и обязанности. Ознакомление с условиями настоящей Политики и нажатие на кнопку «С
                        политикой
                        конфиденциальности ознакомлен» является письменным согласием Пользователя на сбор, хранение,
                        обработку и
                        передачу третьим лицам персональных данных, предоставляемых Пользователем.
                    </li>
                </ul>
                <div>4.2. ООО «ЭфТиЭс» не проверяет достоверность получаемой (собираемой) информации о Пользователях, за
                    исключением случаев, когда такая проверка необходима в целях исполнения обязательств перед
                    Пользователем.
                </div>

                <h3>5. Персональная информация Пользователя</h3>
                <div>5.1. В рамках настоящей Политики под персональными данными Пользователя понимаются личные данные,
                    предоставленные Пользователем самостоятельно при использовании Приложения, в том числе имя, фамилия,
                    номер мобильного телефона и/или адрес электронной почты, дата рождения, адрес места жительства.
                </div>
                <div>5.2. Данные, которые автоматически передаются ПРиложением в процессе их использования с помощью
                    установленного на устройстве Пользователя программного обеспечения, в том числе IP- адрес,
                    информация из cookie, информация о браузере пользователя (или иной программе, с помощью которой
                    осуществляется доступ к Приложению), время доступа.
                </div>
                <div>5.3. Иная информация о Пользователе, сбор и/или предоставление которой определено в Регулирующих
                    документах отдельных услуг ООО «ЭфТиЭс».
                </div>

                <h3>6. Изменение и удаление персональных данных</h3>
                <div>6.1. Пользователь может в любой момент изменить (обновить, дополнить) предоставленную им персональную
                информацию или её часть, а также параметры её конфиденциальности, направив соответствующее уведомление
                по адресу электронной почты help@fintechservice.group Пользователь обязан заботиться о своевременности
                внесения изменений в ранее предоставленную информацию, ее актуализации, в противном случае ООО «ЭфТиЭс»
                    не несет ответственности за неполучение Пользователем уведомлений и услуг.</div>
                <div>6.2. Пользователь вправе потребовать прекращения обработки и использования (удаления) его персональных
                    данных, при этом он понимает, что оказание услуг по договору оферты в дальнейшим считается невозможным.</div>

                <h3>7. Изменение Политики конфиденциальности. Применимое законодательство</h3>
                <div>7.1. ООО «ЭфТиЭс» имеет право вносить изменения в настоящую Политику конфиденциальности. При внесении
                изменений в актуальной редакции указывается дата последнего обновления. Новая редакция Политики вступает
                в силу с момента ее размещения, если иное не предусмотрено новой редакцией Политики. Действующая
                    редакция всегда находится в Приложение.</div>
                <div>7.2. К настоящей Политике и отношениям между Пользователем и ООО «ЭфТиЭс», возникающим в связи с
                    применением Политики конфиденциальности, подлежит применению законодательство Российской Федерации.</div>
                <h3>8. Обратная связь. Вопросы и предложения</h3>
                <div>8.1. Все предложения или вопросы по поводу настоящей Политики следует сообщать по электронной почте <a href={'mailto:help@fintechservice.group'}>help@fintechservice.group</a></div>

            </div>
        </Layout>
    )

}